import { NO_MESSAGE } from '@/constants/common';
import { RequestError } from '@umijs/max';

export interface ruleItem {
  message: string;
  rule: (error: RequestError) => boolean;
}

export const checkRules = (error: RequestError) => {
  const ruleList: ruleItem[] = [
    {
      message: ' 加载超时，请重试！',
      rule: (error: RequestError) =>
        error?.message === 'timeout of 30000ms exceeded'
    },
    {
      // NOTE 这个补丁是全局的 查询用户信息的接口，这个接口必定会调用，但是这个接口不应该弹出错误提示。因为当用户没有用户管理的权限时，它就会弹出这个错误，但是用户在使用 预设话术管理这个页面时，不需要用户管理的权限。
      message: NO_MESSAGE,
      rule: (error: RequestError) =>
        error?.message === '暂无权限操作' && error?.url?.includes?.('/users/search'),
    },
  ];

  return ruleList.find((item) => item?.rule(error))?.message;
};
